import { defineMessages } from "@/lib/i18n/messages";

export default defineMessages({
  es: {
    promptTitle: "¿Quieres escuchar la banda sonora?",
    promptBody: "Suena un fragmento mientras miras la ficha. Puedes silenciarla cuando quieras.",
    accept: "Sí, activar",
    decline: "No, gracias",
    play: "Activar la banda sonora",
    mute: "Silenciar la banda sonora",
    tapToListen: "Toca para escuchar",
    via: "vía Deezer",
  },
  en: {
    promptTitle: "Want to hear the soundtrack?",
    promptBody: "A short clip plays while you browse this title. You can mute it anytime.",
    accept: "Yes, turn on",
    decline: "No, thanks",
    play: "Play the soundtrack",
    mute: "Mute the soundtrack",
    tapToListen: "Tap to listen",
    via: "via Deezer",
  },
});
